import React from 'react';
import { useTranslation } from 'react-i18next';

const FAQ = ()=>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';

    return(
     <section id="FAQ">
        <div className='bg-dark '>
          <div className='container '>
              <div className='h3 text-center text-light py-5 poppins-medium'  style={{ margin: '0 auto' }}>{t('faq.title')}</div>
              <div className={`accordion accordion-flush bg-dark text-light `} id="accordionFlushExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button className={`accordion-button collapsed bg-dark text-light ${isArabic ? "accordion-button-arabic":""}`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    <span className='faq-question poppins-semibold'> {t('faq.question1')}</span>
                    </button>
                  </h2>
                  <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body bg-dark text-light faq-answer poppins-regular">{t('faq.answer1')}</div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button className={`accordion-button collapsed bg-dark text-light ${isArabic ? "accordion-button-arabic":""}`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    <span className='faq-question poppins-semibold'>{t('faq.question2')}</span>
                    </button>
                  </h2>
                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body bg-dark text-light faq-answer poppins-regular">{t('faq.answer2')}</div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button className={`accordion-button collapsed bg-dark text-light ${isArabic ? "accordion-button-arabic":""}`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                      <span className='faq-question poppins-semibold'>{t('faq.question3')}</span>
                    </button>
                  </h2>
                  <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body bg-dark text-light faq-answer poppins-regular">{t('faq.answer3')}</div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingFour">
                    <button className={`accordion-button collapsed bg-dark text-light ${isArabic ? "accordion-button-arabic":""}`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                    <span className='faq-question poppins-semibold'>{t('faq.question4')}</span>
                    </button>
                  </h2>
                  <div id="flush-collapseFour" className="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body bg-dark text-light faq-answer poppins-regular">{t('faq.answer4')}</div>
                  </div>
                </div>
              </div>
 
          </div>
        </div>
     </section>
    );
};

export default FAQ;